import { CardActions } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import useStyles from './LargeCard.styles';
import type { LargeCardProps } from './LargeCard.types';

const LargeCard = (props: LargeCardProps) => {
  const { children, rightContent, title, className, style, actions } = props;
  const { classes } = useStyles();

  return (
    <Card
      className={className ? `${classes.card} ${className}` : classes.card}
      style={style}
    >
      <CardHeader
        className={classes.cardHeader}
        title={title}
        slotProps={{ title: { variant: 'h4' } }}
        subheader={rightContent}
      />
      <CardContent className={classes.cardContent}>{children}</CardContent>
      {actions && (
        <CardActions className={classes.cardActions}>{actions}</CardActions>
      )}
    </Card>
  );
};

export default LargeCard;
